import { render } from "./prop-control.vue?vue&type=template&id=2b8f7862"
import script from "./prop-control.vue?vue&type=script&lang=js"
export * from "./prop-control.vue?vue&type=script&lang=js"

import "./prop-control.vue?vue&type=style&index=0&id=2b8f7862&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__